import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

// The + in the fullscreen shorts overlay. One user gesture opens the native
// camera/gallery chooser: the button click is forwarded to a hidden file
// input (allowed on iOS - same gesture), and the OS supplies both "record
// now" and "pick from library". No `capture` attribute on purpose: with it,
// iOS jumps straight to the camera and the gallery option disappears.
@observer
class ShortsCaptureButton extends Component {
    setInputRef = (el) => {
        this.inputEl = el;
    }

    onButtonClick = () => {
        if (this.inputEl) {
            this.inputEl.click();
        }
    }

    onFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        // Reset so picking the same file twice re-fires change.
        e.target.value = '';
        if (!file) {
            return;
        }
        const { appState } = this.props.stores;
        appState.openDrawer('newShortsClip', {
            height: appState.drawerHeightMediumLarge,
            fileObject: file,
        }, appState.getTopMostDrawer() + 1);
    }

    render() {
        return (<>
            <span
                class='text-white'
                style='cursor: pointer; pointer-events: auto;'
                role='button'
                onClick={this.onButtonClick}
            >
                <i class='fa-solid fa-circle-plus' style='font-size: 1.3rem;' />
                <span class='visually-hidden'>
                    <Text id='shorts.record'>New clip</Text>
                </span>
            </span>
            <input
                ref={this.setInputRef}
                type='file'
                accept='video/*'
                style='display: none;'
                onChange={this.onFileChange}
            />
        </>);
    }
}

export default ShortsCaptureButton;
